import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// withCredentials: include the httpOnly auth cookie on every request.
// The cookie itself is invisible to JS (XSS-safe); the browser attaches it.
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// ─── CSRF double-submit-cookie ──────────────────────────────────────
// On every mutating request, read the `hc_csrf` cookie (set by the backend
// on login) and echo it in the X-CSRF-Token header. The server checks both
// match (constant-time compare) before accepting any state change.
const _UNSAFE_METHODS = new Set(["post", "put", "patch", "delete"]);
function _readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : "";
}
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (_UNSAFE_METHODS.has(method)) {
    const csrf = _readCookie("hc_csrf");
    if (csrf) {
      config.headers = config.headers || {};
      config.headers["X-CSRF-Token"] = csrf;
    }
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Cookie has expired or was cleared server-side. Wipe any cached profile
      // and bounce to /login unless we're already there (or on a public page).
      try {
        localStorage.removeItem("hc_user_profile_cache");
      } catch (_) {}
      const path = window.location.pathname;
      const publicPaths = ["/", "/login", "/signup", "/accept-invite", "/family", "/agency/", "/share/", "/reset-password/", "/invite/", "/forgot-password", "/privacy", "/terms", "/pricing"];
      const isPublic = publicPaths.some((p) => path.startsWith(p));
      if (!isPublic) {
        window.location.href = "/login";
      }
    }
    // 2FA mandatory-enrol redirect — owner/admin/superadmin must enrol before
    // any API outside the small allowlist works. Bounce them to /my-profile
    // (which hosts the 2FA enrolment widget) unless they're already there.
    if (err?.response?.status === 403 && err?.response?.data?.detail === "2fa_required") {
      const path = window.location.pathname;
      if (!path.startsWith("/my-profile") && !path.startsWith("/login")) {
        window.location.href = "/my-profile?enroll_2fa=1";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
